export const SEARCH_BUSINESS_TOTALS_PATH = '/business/totals/search';
export const SEARCH_BUSINESS_TOTALS_BY_PERIOD_PATH = '/business/totals/searchByPeriod';
export const SEARCH_BUSINESS_ACCOUNT_REPORT_PATH = '/business/totals/account/report';
export const SEARCH_BUSINESS_COSTCENTRE_REPORT_PATH = '/business/totals/costcentre/report';
